export default "__VITE_ASSET__DDU9h$MA__"